export function priceFormat(amount: number) {
  if (!amount) return '0';
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function uuidv4() {
  return (1e7)
    .toString()
    .replace(/[018]/g, (c) =>
      (parseInt(c) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (parseInt(c) / 4)))).toString(16)
    );
}
